const USER_TYPE = {
  CLIENT: "Client",
  EMPLOYEE: "Employee",
};

const CLIENT_TYPE = {
  ORGANIZATION: "organization",
  PRIVATE: "private",
};

const ORGANIZATION_TYPE = {
  Metaal: { label: "Metaal (Constructie & Bewerking)", value: "019" },
  Hout: { label: "Hout (Schrijnwerk, Constructie & Bewerking)", value: "018" },
  Bouw: { label: "Bouw & renovatie", value: "100" },
  Installatie: {
    label: "Installatietechnieken (Verwarming - Koeling - ...)",
    value: "01",
  },
  Automatisatie: {
    label: "Automatisatie (Machines - Computer ICT - ...)",
    value: "06",
  },
  Onderhoud: {
    label: "Onderhoud (Onderhoudsdiensten - Gebouwen - ...)",
    value: "63",
  },
  Transport: {
    label: "Transport (Garages - constructeurs - automobiel)",
    value: "04",
  },
  Voeding: { label: "Voeding (Productie en verwerking van ...)", value: "68" },
  Chemie: {
    label: "Chemie (Brandstoffen - Chemicaliën - Gassen - ...)",
    value: "08",
  },
  Scheepswerven: {
    label: "Scheepswerven (Bouw - herstelling - ...)",
    value: "110",
  },
  Landbouw: {
    label: "Landbouw (Land en tuinbouw - GEEN constructie)",
    value: "24",
  },
  Medisch: { label: "Medisch (Ziekenhuizen - instellingen)", value: "021" },
  Onderwijs: { label: "Onderwijs (BSO - TSO - avond - ...)", value: "010" },
  Overheid: {
    label: "Openbare diensten (Steden - Gemeenten - ...)",
    value: "71",
  },
  Beroep: {
    label: "Vrije beroepen (Dokter - Advocaat - Architect - ...)",
    value: "14",
  },
  Andere: {
    label: "Andere (Eerst melden aan verantwoordelijke)",
    value: "020",
  },
};

const ORGANIZATION_ROLE = {
  OWNER: {
    role: "OWNER",
    level: 99,
    label: { nl: "Eigenaar", fr: "Propriétaire", en: "Owner" },
  },
  ADMIN: {
    role: "ADMIN",
    level: 20,
    label: { nl: "Admin", fr: "Admin", en: "Admin" },
  },
  MEMBER: {
    role: "MEMBER",
    level: 10,
    label: { nl: "Lid", fr: "Membre", en: "Member" },
  },
  NONE: {
    role: "NONE",
    level: 0,
    label: { nl: "Geen", fr: "Aucun", en: "None" },
  },
  BLOCKED: {
    role: "BLOCKED",
    level: -1,
    label: { nl: "Geblokkeerd", fr: "Bloqué", en: "Blocked" },
  },
};

const CUSTOMER_CLASS = {
  TK: "Topklant",
  PTK: "Potentieel Topklant",
  SK: "Standaard Klant",
  PSK: "Potentieel Standaard Klant",
};

const CUSTOMER_PAYMENT_TERMS = {
  CASH: "contant",
  CREDIT: "credits",
};

const DEFAULT_ORGANIZATION_CUSTOMER_NUMBER = 999999;
const DEFAULT_PRIVATE_CUSTOMER_NUMBER = 44092;

const CONTACT_TYPE = {
  COMPANY: {
    code: "1",
    label: "Onderneming",
  },
  CONTACT_PERSON: {
    code: "2",
    label: "Contactpersoon",
  },
  DEPARTMENT: {
    code: "4",
    label: "Afdeling",
  },
  DELIVERY: {
    code: "10",
    label: "Afleveradres",
  },
};

module.exports = {
  USER_TYPE,
  CLIENT_TYPE,
  ORGANIZATION_TYPE,
  ORGANIZATION_ROLE,
  CUSTOMER_CLASS,
  CUSTOMER_PAYMENT_TERMS,
  DEFAULT_ORGANIZATION_CUSTOMER_NUMBER,
  DEFAULT_PRIVATE_CUSTOMER_NUMBER,
  CONTACT_TYPE,
};
